import React, { useState, useEffect, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';
import { abstractDataUser } from 'util/isAdmin';
import { sparks as sparksApi } from 'api/sparks';
import { SparksBadgeWrapper } from './styles';

function getCurrentMonthRange() {
	const now   = new Date();
	const year  = now.getFullYear();
	const month = now.getMonth();
	const fmt   = ( d ) => `${d.getFullYear()}-${String( d.getMonth() + 1 ).padStart( 2, '0' )}-${String( d.getDate() ).padStart( 2, '0' )}`;
	return {
		startDate : fmt( new Date( year, month, 1 ) ),
		endDate   : fmt( new Date( year, month + 1, 0 ) ),
	};
}

function SparksBadge( { history } ) {
	const [ sparks, setSparks ] = useState( null );
	const [ loading, setLoading ] = useState( true );

	const { email: userEmail, tenantId: userTenantId } = abstractDataUser();
	const isAdmin = Number( userTenantId ) === 3;

	const fetchUserSparks = useCallback( async () => {
		if ( isAdmin ) {
			setSparks( 0 );
			setLoading( false );
			return;
		}

		try {
			setLoading( true );
			const { startDate, endDate } = getCurrentMonthRange();
			const response = await sparksApi.list( { startDate, endDate } );

			const data = Array.isArray( response.data ) ? response.data : [];
			const userEntry = data.find(
				( item ) =>
					item.email?.toLowerCase() === userEmail?.toLowerCase() &&
					Number( item.tenant_id ) === Number( userTenantId )
			);

			setSparks( userEntry ? ( Number( userEntry.pontuacao ) || 0 ) : 0 );
		} catch {
			setSparks( null );
		} finally {
			setLoading( false );
		}
	}, [ userEmail, userTenantId, isAdmin ] );

	useEffect( () => {
		fetchUserSparks();

		const interval = setInterval( fetchUserSparks, 5 * 60 * 1000 );
		return () => clearInterval( interval );
	}, [ fetchUserSparks ] );

const handleClick = () => {
		history.push( '/app/sparks' );
	};

	return (
		<Tooltip title="Ver ranking de Sparks" arrow>
			<SparksBadgeWrapper onClick={handleClick}>
				<img className="spark-coin-img" src="/sparks/spark.svg" alt="Spark" />
				<div className="spark-info">
					{loading ? (
						<CircularProgress className="spark-loading" size={16} style={{ color: '#fff' }} />
					) : (
						<>
							<span className="spark-count">
								{sparks !== null ? sparks.toLocaleString( 'pt-BR' ) : '—'}
							</span>
							<span className="spark-label">Sparks</span>
						</>
					)}
				</div>
			</SparksBadgeWrapper>
		</Tooltip>
	);
}

export default withRouter( SparksBadge );
